// import { NotFoundPage } from "@/pages/NotFoundPage";
import {
  CheckEmailPage,
  LoginPage,
  RegisterPage,
  VerifyPage,
} from "@/pages/auth";
import { GameInfoPage } from "@/pages/GameInfoPage";
import { GamePlayPage } from "@/pages/GamePlayPage";
import { HomePage } from "@/pages/HomePage";
import { ProfilePage } from "@/pages/ProfilePage";
import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute, PublicRoute } from "./ProtectedRoute";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/game-info/:gameSlug",
    element: <GameInfoPage />,
  },
  {
    path: "/game/:gameSlug",
    element: (
      <ProtectedRoute>
        <GamePlayPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
  },
  {
    path: "/register",
    element: (
      <PublicRoute>
        <RegisterPage />
      </PublicRoute>
    ),
  },
  {
    path: "/verify/check-email",
    element: (
      <PublicRoute>
        <CheckEmailPage />
      </PublicRoute>
    ),
  },
  {
    path: "/verify",
    element: (
      <PublicRoute>
        <VerifyPage />
      </PublicRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <HomePage />,
  },
]);

export default router;
